import { render, staticRenderFns } from "./CaseHistory.vue?vue&type=template&id=196fb7c3"
import script from "./CaseHistory.vue?vue&type=script&lang=js"
export * from "./CaseHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports